import React from "react";

import Load from "../load";
import LoadError from "../loadError";
import LoadSkeleton from "../loadSkeleton";
import LoadErrorText from "../loadErrorText";

const SelectItemWithLoad = ({
  onClick,
  options,
  children,
  errorMessage,
  skeleton = true,
}) =>
  options ? (
    options !== "e" ? (
      children
    ) : onClick ? (
      <LoadError message={errorMessage} onClick={onClick} />
    ) : (
      <LoadErrorText message={errorMessage} />
    )
  ) : skeleton ? (
    <LoadSkeleton />
  ) : (
    <Load size="small" />
  );

export default SelectItemWithLoad;
